import "core-js/modules/es.regexp.exec.js";
import React, { lazy, Suspense } from 'react';
import { Show, ErrorNamespaceProvider, BlockingErrorBoundary } from '@edreamsodigeo/frontend-core';
const MPFunnel = /*#__PURE__*/lazy(() => import(/* webpackChunkName: "membershippagesfunnel" */
'./Funnel'));
const membershipPagesRegex = /\/travel\/membership-pages\//;
export const MembershipPagesFunnel = () => /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
  namespace: "shell_funnel_membership_pages"
}, /*#__PURE__*/React.createElement(BlockingErrorBoundary, {
  name: "funnel_membership_pages"
}, /*#__PURE__*/React.createElement(Show, {
  when: membershipPagesRegex.test(window.location.href)
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(MPFunnel, null)))));